var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190.6 84",
    style: {
      enableBackground: "new 0 0 190.6 84"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000027564234308361787710000001936026069565271198_);}\n\t.st1{fill:#024064;}\n\t.st2{fill:#20E2BD;}\n\t.st3{fill:#9FD983;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.7,
    y: 4.1,
    width: 188.1,
    height: 75.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137814041345967563210000010452693766129266621_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    style: {
      clipPath: "url(#SVGID_00000137814041345967563210000010452693766129266621_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    className: "st1",
    d: "M104.5,32.8c0,3.3-2.6,5.2-7.5,5.2h-9.6V18.8h9c4.6,0,7.1,2,7.1,5c0.1,1.8-0.9,3.4-2.5,4.2 C103.2,28.6,104.6,30.6,104.5,32.8 M91,21.6v5.3H96c2.5,0,3.9-0.9,3.9-2.6c0-1.8-1.4-2.7-3.9-2.7L91,21.6z M100.9,32.4 c0-1.9-1.5-2.8-4.1-2.8H91v5.6h5.8C99.4,35.2,100.9,34.4,100.9,32.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    className: "st1",
    d: "M123,29.6V38h-3.4v-8c0-2.6-1.3-3.9-3.5-3.9c-2.4,0-4.1,1.5-4.1,4.4V38h-3.4V17.6h3.4V25 c1.3-1.3,3.1-2,4.9-1.9C120.4,23.2,123,25.2,123,29.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    className: "st1",
    d: "M140.2,29.4V38H137v-1.8c-0.8,1.3-2.4,2-4.6,2c-3.4,0-5.5-1.8-5.5-4.4c0-2.4,1.6-4.4,6.1-4.4 h3.8v-0.2c0-2-1.2-3.2-3.7-3.2c-1.6,0-3.2,0.5-4.5,1.5l-1.3-2.5c1.8-1.3,4-1.9,6.2-1.8C137.7,23.2,140.2,25.2,140.2,29.4  M136.8,33.4v-1.7h-3.5c-2.3,0-3,0.9-3,2c0,1.2,1,2,2.8,2C134.6,35.8,136.1,34.9,136.8,33.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    className: "st1",
    d: "M153.6,23.2v3.3c-0.3-0.1-0.5-0.1-0.8-0.1c-2.6,0-4.3,1.5-4.3,4.5V38h-3.4V23.3h3.3v2.1 C149.4,23.9,151.2,23.2,153.6,23.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    className: "st1",
    d: "M169.3,29.4V38H166v-1.8c-0.8,1.3-2.4,2-4.6,2c-3.4,0-5.5-1.8-5.5-4.4c0-2.4,1.6-4.4,6.1-4.4 h3.8v-0.2c0-2-1.2-3.2-3.7-3.2c-1.6,0-3.2,0.5-4.5,1.5l-1.3-2.5c1.8-1.3,4-1.9,6.2-1.8C166.8,23.2,169.3,25.2,169.3,29.4  M165.9,33.4v-1.7h-3.5c-2.3,0-3,0.9-3,2c0,1.2,1,2,2.8,2C163.7,35.8,165.2,34.9,165.9,33.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    className: "st1",
    d: "M183.1,37.2c-1,0.7-2.1,1-3.3,1c-3.2,0-5.1-1.7-5.1-4.9v-7.1h-2.4v-2.7h2.4v-3.4h3.4v3.4h3.9 v2.7h-3.9v7c0,1.4,0.7,2.2,2,2.2c0.7,0,1.4-0.2,1.9-0.6L183.1,37.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    className: "st1",
    d: "M86,53.2c0-5.7,4.4-9.9,10.3-9.9c2.9-0.1,5.7,1.1,7.6,3.2l-2.3,2.2c-1.3-1.5-3.2-2.3-5.1-2.3 c-3.7-0.1-6.8,2.9-6.9,6.6s2.9,6.8,6.6,6.9c0.1,0,0.2,0,0.3,0c2,0,3.8-0.8,5.1-2.3l2.3,2.2c-1.9,2.2-4.7,3.3-7.6,3.2 C90.4,63.1,86,58.9,86,53.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    className: "st1",
    d: "M119.8,54.2v8.6h-3.2V61c-0.8,1.3-2.4,2-4.6,2c-3.4,0-5.5-1.8-5.5-4.4c0-2.4,1.6-4.4,6.1-4.4 h3.8V54c0-2-1.2-3.2-3.7-3.2c-1.6,0-3.2,0.5-4.5,1.5l-1.3-2.5c1.8-1.3,4-1.9,6.2-1.8C117.3,48,119.8,50,119.8,54.2 M116.3,58.2 v-1.7h-3.5c-2.3,0-3,0.9-3,2c0,1.2,1,2,2.8,2C114.2,60.6,115.7,59.7,116.3,58.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    className: "st1",
    d: "M133.2,48v3.3c-0.3-0.1-0.5-0.1-0.8-0.1c-2.6,0-4.3,1.5-4.3,4.5v7.1h-3.4V48.1h3.3v2.1 C129,48.7,130.7,48,133.2,48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    className: "st1",
    d: "M152.2,55.5c0.2,3.9-2.8,7.3-6.7,7.5c-0.2,0-0.5,0-0.7,0c-1.9,0.1-3.6-0.7-4.9-2.1v1.9h-3.3 V42.4h3.4v7.5c1.2-1.3,2.9-2,4.7-2c3.9-0.2,7.3,2.9,7.5,6.8C152.2,55,152.2,55.2,152.2,55.5 M148.7,55.5c-0.1-2.4-2.2-4.3-4.6-4.1 c-2.4,0.1-4.3,2.2-4.1,4.6c0.1,2.3,2,4.1,4.4,4.1c2.4,0,4.3-1.8,4.4-4.2C148.8,55.7,148.8,55.6,148.7,55.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    className: "st1",
    d: "M188.8,54.4v8.4h-3.4v-8c0-2.6-1.3-3.9-3.5-3.9c-2.4,0-4.1,1.5-4.1,4.4v7.4h-3.4V48.1h3.3V50 c1.3-1.4,3.1-2.2,5.1-2.1C186.2,48,188.8,50,188.8,54.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    className: "st1",
    d: "M162.5,48.1c-0.6,0-1.2,0.1-1.9,0.2c0.8,0.5,1.2,1.4,1.2,2.4c0,0.1,0,0.3,0,0.4 c0.2,0,0.4,0,0.7,0c2.5-0.1,4.7,1.8,4.9,4.3c0.1,2.5-1.8,4.7-4.3,4.9c-2.5,0.1-4.7-1.8-4.9-4.3c0-0.1,0-0.2,0-0.3 c0-0.8,0.1-1.5,0.5-2.2c-1.2-0.2-2.2-1.2-2.4-2.5c-1,1.3-1.6,3-1.6,4.7c0,4.4,3.3,7.5,7.8,7.5c4.6,0,7.8-3.1,7.8-7.5 S167.1,48.1,162.5,48.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    className: "st2",
    d: "M161.1,50.5c0,1.1-0.9,1.9-2,1.9c-1.1,0-1.9-0.9-1.9-2c0-1.1,0.9-1.9,2-1.9c0,0,0,0,0,0 C160.3,48.6,161.1,49.5,161.1,50.5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    className: "st3",
    d: "M159.7,54.3V57c0,0.2,0.1,0.3,0.2,0.4l2.3,1.3c0.1,0.1,0.3,0.1,0.5,0l2.3-1.3 c0.1-0.1,0.2-0.2,0.2-0.4v-2.7c0-0.2-0.1-0.3-0.2-0.4l-2.3-1.3c-0.1-0.1-0.3-0.1-0.5,0l-2.3,1.3C159.8,53.9,159.7,54.1,159.7,54.3 "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    className: "st2",
    d: "M46.3,75.4c-2.3-0.1-4.1-2-4.1-4.3c0.1-2.2,1.9-4,4.1-4.1c2.3,0,4.2,1.9,4.1,4.2 C50.5,73.6,48.6,75.4,46.3,75.4L46.3,75.4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    className: "st2",
    d: "M34.9,71.2c0,2.3-1.8,4.2-4.1,4.2c0,0,0,0,0,0c-2.3,0-4.2-1.9-4.1-4.2c0-2.3,1.8-4.1,4.1-4.1 C33,67,34.9,68.8,34.9,71.2C34.9,71.2,34.9,71.2,34.9,71.2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    className: "st2",
    d: "M64.1,20.7c0,2.3-1.8,4.2-4.1,4.2c-2.3,0-4.2-1.8-4.2-4.1c0-2.3,1.8-4.2,4.1-4.2 S64.1,18.3,64.1,20.7C64.1,20.7,64.1,20.7,64.1,20.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    className: "st2",
    d: "M59.9,67.6c-2.3,0-4.1-1.9-4.1-4.2c0,0,0-0.1,0-0.1c0-2.3,1.9-4.1,4.2-4.1 c2.3,0,4.1,1.9,4.1,4.2c0,2.3-1.8,4.1-4.1,4.1C59.9,67.6,59.9,67.6,59.9,67.6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    className: "st2",
    d: "M13.1,63.2c0.1-2.3,2-4,4.2-4c0,0,0.1,0,0.1,0c2.3,0.2,4,2.1,3.9,4.4c-0.1,2.2-2,3.9-4.3,3.9 c-2.3-0.1-4-1.9-4-4.2C13.1,63.3,13.1,63.2,13.1,63.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    className: "st2",
    d: "M71.9,49.8c0.1,2.3-1.8,4.2-4.1,4.3c-2.3,0.1-4.2-1.8-4.3-4.1c-0.1-2.3,1.8-4.2,4.1-4.3 c0,0,0,0,0,0C70,45.7,71.9,47.5,71.9,49.8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    className: "st2",
    d: "M50.6,12.9c0,2.3-1.9,4.1-4.2,4.1c-2.3,0-4.1-1.9-4.1-4.2c0-2.3,1.9-4.1,4.2-4.1 C48.8,8.7,50.6,10.6,50.6,12.9C50.6,12.9,50.6,12.9,50.6,12.9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    className: "st2",
    d: "M17.4,16.5c2.3,0.1,4.1,2,4,4.3c-0.1,2.2-1.9,4-4.1,4c-2.3,0-4.1-1.9-4.1-4.2 C13.2,18.3,15.1,16.5,17.4,16.5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    className: "st2",
    d: "M72,34.3c-0.1,2.3-1.9,4.1-4.2,4.1c-2.3,0-4.1-1.9-4.1-4.2c0,0,0,0,0,0c0-2.3,1.9-4.2,4.2-4.2 c2.3,0,4.2,1.9,4.2,4.2C72,34.2,72,34.3,72,34.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    className: "st2",
    d: "M30.9,8.7c2.3,0,4.1,1.9,4.1,4.2c0,0,0,0,0,0c0,2.3-1.9,4.1-4.2,4.1s-4.1-1.9-4.1-4.2 C26.7,10.5,28.5,8.7,30.9,8.7C30.8,8.7,30.9,8.7,30.9,8.7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    className: "st2",
    d: "M9.4,45.7c2.3,0,4.1,1.9,4.1,4.2c0,0,0,0,0,0.1c0,2.3-1.9,4.2-4.2,4.1c-2.3,0-4.2-1.9-4.1-4.2 c0,0,0-0.1,0-0.1C5.3,47.4,7.2,45.6,9.4,45.7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    className: "st2",
    d: "M9.4,38.3c-2.3,0-4.1-1.9-4.1-4.1c0,0,0-0.1,0-0.1c0-2.3,1.9-4.1,4.2-4.1s4.1,1.9,4.1,4.2 C13.6,36.5,11.7,38.3,9.4,38.3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    className: "st2",
    d: "M59.3,71.9c-0.1,1.9-1.7,3.5-3.6,3.4c-2-0.1-3.5-1.7-3.4-3.6c0.1-2,1.7-3.5,3.6-3.4 C57.8,68.3,59.3,69.9,59.3,71.9C59.3,71.9,59.3,71.9,59.3,71.9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    className: "st2",
    d: "M26.6,24.7c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.5,3.5,3.5 C30.1,23.1,28.6,24.7,26.6,24.7C26.6,24.7,26.6,24.7,26.6,24.7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    className: "st2",
    d: "M62.9,30c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5S62.9,28,62.9,30"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    className: "st2",
    d: "M54.1,62.8c0,1.9-1.5,3.5-3.5,3.5c-1.9,0-3.5-1.5-3.5-3.5c0-2,1.5-3.6,3.5-3.6 C52.5,59.2,54.1,60.8,54.1,62.8C54.1,62.7,54.1,62.8,54.1,62.8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    className: "st2",
    d: "M26.5,59.3c2,0,3.6,1.5,3.6,3.5s-1.5,3.6-3.5,3.6c-1.9,0-3.5-1.5-3.6-3.5 C23,60.9,24.5,59.3,26.5,59.3C26.5,59.3,26.5,59.3,26.5,59.3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    className: "st2",
    d: "M24.9,71.8c0,1.9-1.7,3.5-3.6,3.4c-1.9,0-3.5-1.7-3.4-3.6c0-1.9,1.6-3.5,3.5-3.4 C23.3,68.2,24.9,69.8,24.9,71.8C24.9,71.8,24.9,71.8,24.9,71.8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    className: "st2",
    d: "M17.8,26.5c1.9,0,3.5,1.5,3.5,3.4c0,0,0,0.1,0,0.1c0,1.9-1.6,3.5-3.6,3.5 c-1.9,0-3.4-1.5-3.5-3.5c0-1.9,1.5-3.5,3.4-3.6C17.7,26.5,17.7,26.5,17.8,26.5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    className: "st2",
    d: "M62.9,54c0,2-1.5,3.6-3.5,3.6c-2,0-3.6-1.5-3.6-3.5s1.5-3.6,3.5-3.6c0,0,0,0,0,0 C61.2,50.4,62.8,52,62.9,54C62.9,53.9,62.9,53.9,62.9,54"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    className: "st2",
    d: "M66.1,42c0,1.9-1.5,3.5-3.4,3.5c0,0-0.1,0-0.1,0c-1.9,0-3.5-1.6-3.5-3.6c0-1.9,1.5-3.4,3.4-3.5 c1.9-0.1,3.5,1.4,3.6,3.3C66.1,41.9,66.1,41.9,66.1,42"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    className: "st2",
    d: "M17.7,57.5c-1.9,0-3.5-1.6-3.5-3.6c0-1.9,1.6-3.4,3.5-3.5c1.9,0,3.5,1.5,3.6,3.5 s-1.5,3.5-3.5,3.6C17.8,57.5,17.8,57.5,17.7,57.5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    className: "st2",
    d: "M76.5,42c0,1.9-1.6,3.5-3.6,3.5s-3.5-1.6-3.5-3.6c0-1.9,1.6-3.5,3.5-3.5 C74.9,38.5,76.5,40,76.5,42C76.5,42,76.5,42,76.5,42"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    className: "st2",
    d: "M14.6,45.5c-1.9,0-3.5-1.5-3.6-3.5c0-1.9,1.5-3.5,3.5-3.6l0,0c1.9-0.1,3.6,1.5,3.6,3.4 c0.1,1.9-1.5,3.6-3.4,3.6C14.7,45.5,14.6,45.5,14.6,45.5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    className: "st2",
    d: "M64.8,59.1c0-1.9,1.6-3.5,3.6-3.5s3.5,1.6,3.5,3.6c0,2-1.6,3.5-3.6,3.5 C66.4,62.7,64.8,61.1,64.8,59.1C64.8,59.2,64.8,59.1,64.8,59.1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    className: "st2",
    d: "M68.3,28.3c-1.9,0-3.5-1.5-3.5-3.4c0,0,0-0.1,0-0.1c0-1.9,1.6-3.5,3.6-3.5 c1.9,0,3.5,1.6,3.5,3.6C71.8,26.8,70.2,28.3,68.3,28.3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    className: "st2",
    d: "M47.1,21.2c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5c0,1.9-1.5,3.5-3.5,3.5 C48.7,24.8,47.1,23.2,47.1,21.2C47.1,21.3,47.1,21.3,47.1,21.2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    className: "st2",
    d: "M55.8,15.8c-1.9,0-3.5-1.6-3.5-3.6c0-1.9,1.6-3.5,3.6-3.5c1.9,0,3.5,1.7,3.4,3.6 C59.2,14.2,57.7,15.7,55.8,15.8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    className: "st2",
    d: "M38.5,72.9c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.6,3.5-3.5,3.5c-1.9,0-3.5-1.5-3.5-3.5 c-0.1-1.9,1.4-3.5,3.3-3.6C38.4,72.9,38.5,72.9,38.5,72.9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    className: "st2",
    d: "M12.3,59.2c0,1.9-1.5,3.5-3.4,3.5c0,0-0.1,0-0.1,0c-2,0-3.5-1.6-3.5-3.6c0,0,0,0,0,0 c0-1.9,1.6-3.4,3.5-3.5c1.9-0.1,3.5,1.4,3.6,3.3C12.3,59.1,12.3,59.1,12.3,59.2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    className: "st2",
    d: "M8.8,21.3c1.9,0,3.5,1.6,3.5,3.5c0,1.9-1.5,3.4-3.4,3.5c-1.9,0-3.5-1.5-3.6-3.4 c0-1.9,1.5-3.5,3.4-3.6C8.7,21.3,8.8,21.3,8.8,21.3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    className: "st2",
    d: "M42.1,66.1c-0.1,1.9-1.7,3.5-3.6,3.4c-1.9-0.1-3.5-1.7-3.4-3.6s1.7-3.5,3.6-3.4 C40.6,62.5,42.1,64.1,42.1,66.1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    className: "st2",
    d: "M24.9,12.2c0,1.9-1.6,3.5-3.6,3.5c-1.9,0-3.4-1.5-3.5-3.4c0-1.9,1.5-3.6,3.4-3.6 c1.9,0,3.6,1.5,3.6,3.4C24.9,12.2,24.9,12.2,24.9,12.2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    className: "st2",
    d: "M4.2,45.5c-1.9,0-3.5-1.6-3.5-3.5c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5 C7.7,43.9,6.2,45.5,4.2,45.5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    className: "st2",
    d: "M38.5,21.5c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5 c0,1.9-1.5,3.5-3.4,3.5C38.6,21.5,38.6,21.5,38.5,21.5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    className: "st2",
    d: "M38.6,4.1c1.9,0,3.5,1.5,3.5,3.4c0,0,0,0.1,0,0.1c0,1.9-1.6,3.5-3.5,3.5 c-1.9,0-3.5-1.6-3.5-3.5c0,0,0-0.1,0-0.1C35.1,5.6,36.6,4.1,38.6,4.1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    className: "st3",
    d: "M25.5,44.4c-1.4,0-2.5-1.1-2.5-2.4c0,0,0,0,0,0c0.1-1.3,1.1-2.3,2.4-2.4c1.3,0,2.4,1.1,2.4,2.5 C27.8,43.3,26.8,44.4,25.5,44.4"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    className: "st3",
    d: "M54.1,42.1c-0.1,1.3-1.1,2.3-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 C53,39.6,54.1,40.7,54.1,42.1C54.1,42,54.1,42,54.1,42.1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    className: "st3",
    d: "M23.1,49.4c0.1-1.3,1.2-2.3,2.5-2.3c1.3,0.1,2.4,1.2,2.3,2.5C27.8,51,26.7,52,25.3,52 C24,51.8,23,50.7,23.1,49.4"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    className: "st3",
    d: "M51.7,32c1.4,0,2.4,1.2,2.4,2.5c-0.1,1.3-1.2,2.3-2.5,2.3c-1.3-0.1-2.4-1.2-2.3-2.5 C49.3,33,50.4,32,51.7,32"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    className: "st3",
    d: "M51.7,47.1c1.3,0,2.4,1.1,2.4,2.5c0,1.3-1,2.3-2.3,2.4c-1.3,0-2.4-1.1-2.4-2.4 C49.3,48.2,50.3,47.2,51.7,47.1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    className: "st3",
    d: "M27.9,34.4c0,1.3-1,2.4-2.4,2.4c-1.3,0-2.4-1-2.5-2.4c0-1.3,1-2.4,2.4-2.5c0,0,0.1,0,0.1,0 C26.8,32.1,27.9,33.1,27.9,34.4"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    className: "st3",
    d: "M47.5,38.3c-0.1,1.3-1.1,2.3-2.4,2.3c-1.3,0-2.4-1-2.4-2.3c0-0.1,0-0.1,0-0.2 c0-1.3,1.1-2.3,2.3-2.3c1.3,0,2.4,1,2.5,2.3C47.5,38.2,47.5,38.3,47.5,38.3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    className: "st3",
    d: "M45.1,55.7c-1.3,0-2.4-1.1-2.3-2.4c0-1.3,1.1-2.3,2.3-2.3c1.3,0,2.4,1.1,2.4,2.4c0,0,0,0,0,0.1 C47.5,54.7,46.4,55.7,45.1,55.7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    className: "st3",
    d: "M32,35.8c1.3,0,2.4,1,2.4,2.3c0,0,0,0,0,0c0.1,1.3-0.9,2.4-2.2,2.4c0,0-0.1,0-0.1,0 c-1.3,0-2.4-1-2.5-2.3C29.6,37,30.6,35.9,32,35.8C32,35.8,32,35.8,32,35.8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    className: "st3",
    d: "M38.6,39.6c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4c0,0,0,0,0,0 C36.2,40.7,37.2,39.6,38.6,39.6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    className: "st3",
    d: "M32.1,48.2c-1.3,0-2.4-1-2.5-2.3c0,0,0-0.1,0-0.1c0.1-1.3,1.1-2.3,2.3-2.3c1.3,0,2.4,1,2.4,2.3 c0,0,0,0,0,0C34.5,47,33.5,48.1,32.1,48.2C32.2,48.2,32.1,48.2,32.1,48.2"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    className: "st3",
    d: "M47.5,45.8c0,1.3-1.1,2.3-2.3,2.3c-1.3,0-2.4-1-2.5-2.3c0-0.1,0-0.1,0-0.2c0-1.3,1-2.3,2.3-2.3 C46.4,43.4,47.5,44.4,47.5,45.8C47.5,45.8,47.5,45.8,47.5,45.8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    className: "st3",
    d: "M41,34.5c0,1.3-1.2,2.4-2.5,2.3c-1.3,0-2.4-1.2-2.3-2.5c0-1.3,1.2-2.4,2.5-2.3c0,0,0,0,0,0 C40,32.1,41,33.2,41,34.5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    className: "st3",
    d: "M38.6,59.5c-1.3,0-2.4-1.1-2.4-2.4s1.1-2.4,2.4-2.4s2.4,1.1,2.4,2.4c0,0,0,0,0,0 C40.9,58.4,39.9,59.5,38.6,59.5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    className: "st3",
    d: "M41,49.5c0,1.3-1,2.4-2.4,2.4c-1.3,0-2.4-1-2.4-2.4s1-2.4,2.4-2.4c0,0,0,0,0,0 C39.9,47.2,40.9,48.2,41,49.5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    className: "st3",
    d: "M41,27c0,1.3-1.1,2.4-2.5,2.4c-1.3,0-2.4-1.1-2.4-2.5c0-1.3,1.1-2.4,2.5-2.4c0,0,0,0,0,0 C40,24.6,41,25.7,41,27"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    className: "st3",
    d: "M32.1,28.3c1.3,0.1,2.3,1.2,2.3,2.5c-0.1,1.3-1.1,2.3-2.4,2.3c-1.3,0-2.4-1.1-2.4-2.5 c0,0,0,0,0-0.1C29.7,29.2,30.8,28.2,32.1,28.3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    className: "st3",
    d: "M32.1,50.9c1.3,0,2.4,1.1,2.3,2.5c0,1.3-1,2.3-2.3,2.3c0,0-0.1,0-0.1,0c-1.3,0-2.4-1.1-2.4-2.4 c0,0,0,0,0,0C29.7,52,30.8,50.9,32.1,50.9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    className: "st3",
    d: "M45,33.1c-1.3,0-2.4-1.1-2.3-2.4c0-1.3,1-2.3,2.3-2.3c0,0,0.1,0,0.1,0c1.3,0,2.4,1.1,2.4,2.4 c0,0,0,0,0,0C47.4,32,46.4,33.1,45,33.1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cbe6626eee579b0a2645b28bde171091.svg";
export { ForwardRef as ReactComponent };